import { Action, Module, VuexModule, getModule } from 'vuex-module-decorators';
import store from '@/store';

import { ULID } from '../models';
import { fileApi } from '../api';

@Module({
	namespaced: true,
	name: 'media',
	store,
	dynamic: true
})
class MediaModule extends VuexModule {
	@Action({ rawError: true })
	async fileUpload(obj: { mediaID: ULID; file: File; fn: any }): Promise<void> {
		try {
			await fileApi.post(`file/${obj.mediaID}`, obj.file, {
				onUploadProgress: obj.fn
			});
		} catch (error) {
			throw error;
		}
	}
}

export default getModule(MediaModule);
